export default __webpack_public_path__ + "static/media/nr.d2dfb949.svg";